import { useDraggable } from '@dnd-kit/core';
import type { ReactNode } from 'react';

interface DraggableSlotProps {
  id: string;
  data: Record<string, any>;
  children: ReactNode;
  disabled?: boolean;
}

export function DraggableSlot({ id, data, children, disabled }: DraggableSlotProps) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id,
    data,
    disabled,
  });

  return (
    <div
      ref={disabled ? undefined : setNodeRef}
      {...(disabled ? {} : listeners)}
      {...(disabled ? {} : attributes)}
      style={{
        opacity: isDragging ? 0.5 : 1,
        touchAction: disabled ? 'auto' : 'none',
      }}
    >
      {children}
    </div>
  );
}
